import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useContext } from "react";
import { userSelector } from "../app/selectors";
import { useApi } from "../app/hooks";
import { LanguageContext } from "components/language";
import "react-toastify/dist/ReactToastify.css";
import Header from "./Header";

function Layout() {
  const user = useSelector(userSelector);
  const { t } = useContext(LanguageContext);

  const { data: languages } = useApi("language/list");

  if (!user.isAuth) return <Navigate to="/sign-in" />;

  return (
    <div className="layout">
      {/* <div className="sidebar"> */}
      {/* <div className="sidebar-content beauty_scrollbar"> */}
      {/* <div className="sidebar-content__header">
            <Box display={{ xs: "flex", md: "none" }} justifyContent={"flex-end"} padding={"10px"}>
              <IconButton onClick={() => setSidebarOpen(false)}>
                <CustomIcon icon="exit" />
              </IconButton>
            </Box>
            <Select
              className="defaultHotel"
              IconComponent={ArrowIcon}
              sx={{ "& fieldset": { boxShadow: "none !important" } }}
              onChange={(e) => {
                handleChangeActiveHotel(e.target.value);
              }}
              MenuProps={{
                PopoverClasses: {
                  paper: "hotels_select_body beauty_scrollbar",
                },
              }}
              defaultValue={get(user, "activeHotelId")}
            >
              {get(user, "hotel", []).map((option) => (
                <MenuItem key={option.id ?? option.value} value={option.id ?? option.value}>
                  {option.title ?? option.name}
                </MenuItem>
              ))}
            </Select>
          </div>
          <ul className="list">
            {pages.DASHBOARDS ? (
              <Link to="/dashboard">
                <li
                  className={cn("list-item", {
                    active: pathname === "/dashboard",
                  })}
                >
                  <WidgetIcon className="iconRoot" />
                  <span className="list-item__text">{t("DASHBOARD")}</span>
                </li>
              </Link>
            ) : null}

            {pages.ORDERS ? (
              <Link to="/orders">
                <li
                  className={cn("list-item", {
                    active: pathname === "/orders",
                  })}
                >
                  <BagIcon className="iconRoot" />
                  <span className="list-item__text">{t("ORDERS")}</span>
                </li>
              </Link>
            ) : null}
            {pages.EMPLOYEE ? (
              <Link to="/employee">
                <li
                  className={cn("list-item", {
                    active: pathname === "/employee",
                  })}
                >
                  <UserIcon className="iconRoot" />
                  <span className="list-item__text">{t("USERS")}</span>
                </li>
              </Link>
            ) : null}
            {pages.HOTELS ? (
              <Link to="/hotels">
                <li
                  className={cn("list-item", {
                    active: pathname === "/hotels",
                  })}
                >
                  <CustomIcon icon="hotel" className="iconRoot" />
                  <span className="list-item__text">{t("HOTELS")}</span>
                </li>
              </Link>
            ) : null}
            {pages.MYHOTEL ? (
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <li
                      className={cn("list-item myhotel", {
                        active: !!submenu.find((item) => pathname === `/${item.name}`),
                      })}
                      {...bindHover(popupState)}
                    >
                      <CustomIcon icon="myhotel" className="iconRoot" />
                      <span className="name list-item__text">{t("MY_HOTEL")}</span>
                      <IconButton>
                        <KeyboardArrowDownIcon />
                      </IconButton>
                    </li>

                    <HoverMenu className="sidebar-submenu" {...bindMenu(popupState)}>
                      {submenu.map((item, i) => (
                        <Link
                          key={i}
                          className={cn("", {
                            active: pathname === `/${item.name}`,
                          })}
                          onClick={() => {
                            popupState.close();
                          }}
                          to={item.name}
                        >
                          <MenuItem>{item.title}</MenuItem>
                        </Link>
                      ))}
                    </HoverMenu>
                  </React.Fragment>
                )}
              </PopupState>
            ) : null}
            {pages.PRICES ? (
              <Link to="/prices">
                <li
                  className={cn("list-item", {
                    active: pathname === "/prices",
                  })}
                >
                  <CustomIcon icon="calendar-money" className="iconRoot" />
                  <span className="list-item__text">{t("PRICES")}</span>
                </li>
              </Link>
            ) : null}
            {pages.BILLING ? (
              <Link to="/billing">
                <li
                  className={cn("list-item", {
                    active: pathname === "/billing",
                  })}
                >
                  <CustomIcon icon="billing" className="iconRoot" />
                  <span className="list-item__text">{t("BILLING")}</span>
                </li>
              </Link>
            ) : null}
            {pages.INTEGRATION ? (
              <Link to="/integration">
                <li
                  className={cn("list-item", {
                    active: pathname === "/integration",
                  })}
                >
                  <CloseFullscreenOutlinedIcon className="iconRoot" />
                  <span className="list-item__text">{t("INTEGRATION")}</span>
                </li>
              </Link>
            ) : null}
            {pages.PRICES ? (
              <Link to="/design">
                <li
                  className={cn("list-item", {
                    active: pathname === "/design",
                  })}
                >
                  <CustomIcon className="iconRoot" icon="custom-design" />
                  <span className="list-item__text">{t("DESIGN")}</span>
                </li>
              </Link>
            ) : null}
            {pages.SETTINGS ? (
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <li
                      className={cn("list-item myhotel", {
                        active: !!submenuSettings.find((item) => pathname === `/${item.name}`),
                      })}
                      {...bindHover(popupState)}
                    >
                      <CustomIcon icon="settings" className="iconRoot" />
                      <span className="list-item__text">{t("SETTINGS")}</span>
                      <IconButton>
                        <KeyboardArrowDownIcon />
                      </IconButton>
                    </li>

                    <HoverMenu className="sidebar-submenu" {...bindMenu(popupState)}>
                      {submenuSettings.map((item, i) => (
                        <Link
                          key={i}
                          className={cn("", {
                            active: pathname === `/${item.name}`,
                          })}
                          onClick={() => {
                            popupState.close();
                          }}
                          to={item.name}
                        >
                          <MenuItem>{item.title}</MenuItem>
                        </Link>
                      ))}
                    </HoverMenu>
                  </React.Fragment>
                )}
              </PopupState>
            ) : null}
          </ul> */}
      {/* </div> */}
      {/* <div className="sidebar-toggle">
          <IconButton
            onClick={() => setSidebarOpen((s) => !s)}
            sx={{
              background: "rgba(13, 140, 235, 0.1)",
              "&:hover": { background: "rgba(13, 140, 235, 0.1)" },
            }}
          >
            <CustomIcon icon="arrow-right" />
          </IconButton>
        </div> */}
      {/* </div> */}

      <Header {...{ languages, user, t }} />

      <Outlet context={{ languages }} />
    </div>
  );
}

export default Layout;
